/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_not_found_go_back = /** @type {(inputs: {}) => string} */ () => {
	return `Volver atrás`
};

const en_not_found_go_back = /** @type {(inputs: {}) => string} */ () => {
	return `Go back`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const not_found_go_back = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.not_found_go_back(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("not_found_go_back", locale)
	if (locale === "es") return es_not_found_go_back(inputs)
	return en_not_found_go_back(inputs)
};
export { not_found_go_back as "not_found.go_back" }